import React from 'react';
import { sortBy } from 'lodash';
import * as Styled from './style';
import CellComment from './CellComment';
import type { SchemaCommentMessageResponseSchema } from '../../../../../../api/generated/schema';

interface CellCommentsListProps {
  comments?: SchemaCommentMessageResponseSchema[];
  refetchComments: () => Promise<unknown>;
}

const CellCommentsList = ({ comments = [], refetchComments }: CellCommentsListProps) => {
  const sortedComments = sortBy(comments, 'created_at');

  const renderComments = () => {
    if (!Array.isArray(sortedComments) || !sortedComments.length) return null;

    return sortedComments.map(comment =>
      comment?.id ? (
        <CellComment
          key={comment.id}
          comment={comment}
          totalComments={sortedComments.length}
          refetchComments={refetchComments}
        />
      ) : null
    );
  };

  return (
    <Styled.MessagesList id="cell-comments-list" data-testid="messages-list">
      {renderComments()}
    </Styled.MessagesList>
  );
};

export default CellCommentsList;
